import ContactUs from "../componenet/form/ContactUs.js";

const ContactSection = () => {
  return (
    <section
      id="contact"
      className="max-w-7xl mx-auto px-6 py-20 relative w-full overflow-hidden"
      data-aos="fade-up"
    >

      <div className="text-center mb-12">
        <h2 className="text-4xl font-extrabold text-primary">📩 Contact Us</h2>
        <p className="text-gray-300 mt-3 text-lg">
        Let’s build something that gets noticed.<br />
        We offer custom quotes based on your needs.<br />
        Fill out this quick form — we’ll reply in 24 hours.
        </p>
      </div>

      <ContactUs />
    </section>
  );
};

export default ContactSection;
